import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { useConfig } from "@geome/react-next/lib/hooks/config";
import { SectionWithTitle } from "../sectionWithTitle";
const FuelPrices = ({ sectionName, configPath, data, sectionProps, }) => {
    const { currency, precision, unit, prices, updated, country_code: countryCode } = data;
    const { translate } = useI18n();
    const enabledFuels = useConfig(`${configPath}sections.${sectionName}.enabled`, false);
    const fuelsAndPrices = enabledFuels
        .filter((fuelName) => prices[fuelName] !== undefined)
        .map((fuelName) => ({ fuelName, price: prices[fuelName] }));
    const hasPrices = fuelsAndPrices.some(({ price }) => price !== null);
    return (_jsxs(SectionWithTitle, { id: sectionName, sectionTokenPath: `${configPath}sections.${sectionName}`, className: "", ...sectionProps, children: [_jsx("table", { className: "fuel-prices__table", children: _jsx("tbody", { children: fuelsAndPrices.map(({ fuelName, price }) => (_jsx(FuelTableRow, { fuelName: fuelName, countryCode: countryCode, price: price, precision: precision, currency: currency, unit: unit, intlPath: `${configPath}sections.${sectionName}` }, fuelName))) }) }), hasPrices && (_jsxs(_Fragment, { children: [_jsx("div", { className: "fuel-prices__disclaimer", children: translate(`${configPath}sections.${sectionName}.fuel_prices.disclaimer`) }), updated && (_jsx("div", { className: "fuel-prices__last-updated", children: translate(`${configPath}sections.${sectionName}.last_updated`, {
                            updated: new Date(updated),
                        }) }))] }))] }));
};
const FormattedPricePerUnit = ({ price, currency, unit, precision = 3, intlPath, }) => {
    const { translate } = useI18n();
    if (price === null)
        return _jsx(_Fragment, { children: translate(`${intlPath}.fuel_prices.null_price`) });
    return (_jsx(_Fragment, { children: translate(`${intlPath}.price_per_unit`, {
            price,
            unit,
            formats: {
                number: {
                    fuelPrice: {
                        currency,
                        style: "currency",
                        maximumFractionDigits: precision,
                        minimumFractionDigits: precision,
                    },
                },
            },
        }) }));
};
const FuelTableRow = ({ fuelName, countryCode, price, precision, currency, unit, intlPath, }) => {
    const { translate } = useI18n();
    return (_jsxs("tr", { className: "fuel-prices__table-row", children: [_jsx("th", { scope: "row", className: "fuel-prices__fuel-name", children: translate(`fuel_local_names.${fuelName}`, {
                    countryCode,
                }) }), _jsx("td", { className: "fuel-prices__fuel-price", children: _jsx(FormattedPricePerUnit, { price: price, precision: precision, currency: currency, unit: unit, intlPath: intlPath }) })] }));
};
export { FuelPrices };
